module.exports = __webpack_public_path__ + "img/ic_homestay_apply_item_img4.93cd8f2e.png";